<script>
export default {
  data() {
    return {
      sitekey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
      widgetId: 0,
    }
  },
  mounted() {
    // render the recaptcha widget when the component is mounted
    this.render()
  },
  methods: {
    render() {
      setTimeout(
        function() {
          if (
            typeof window.grecaptcha === 'undefined' ||
            typeof window.grecaptcha.render === 'undefined'
          ) {
            this.render()
          } else {
            window.grecaptcha.render('g-recaptcha', {
              sitekey: this.sitekey,
              callback: (response) => {
                // emit an event called verify with the response as payload
                this.$emit('verify', response)
              },
              'expired-callback': () => {
                this.$emit('reset', true)
              },
            })
          }
        }.bind(this),
        100
      )
    },
  },
}
</script>

<template>
  <div id="g-recaptcha" class="g-recaptcha mb-6" :data-sitekey="sitekey"> </div>
</template>

<style lang="scss">
#g-recaptcha {
  -webkit-transform: scale(1.08, 1);
  transform: scale(1.08, 1);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
</style>
